// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".drfSmgCompanyCustomer[data-v-2a84fed0] {\n  width: 100%;\n}\n.drfSmgCompanyCustomer[data-v-2a84fed0]  .el-form-item__content {\n  width: auto !important;\n}\n.drfSmgCompanyCustomer[data-v-2a84fed0]  .el-form-item__content .el-textarea.is-disabled .el-textarea__inner {\n  color: #000;\n  min-height: 2.1875rem !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
